export const InfoIcon = ({
  size = 24,
  ...otherProps
}: {
  size?: number | string
} & React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 10 10"
      {...otherProps}
    >
      <path
        d="M5.00001 9.16732C7.3012 9.16732 9.16668 7.30184 9.16668 5.00065C9.16668 2.69946 7.3012 0.833984 5.00001 0.833984C2.69882 0.833984 0.833344 2.69946 0.833344 5.00065C0.833344 7.30184 2.69882 9.16732 5.00001 9.16732Z"
        className="fill-none stroke-current"
        strokeWidth="0.833333"
      />
      <path
        d="M5 2.91602H5.00417"
        className="stroke-current"
        strokeWidth="0.833333"
        strokeLinecap="round"
      />
      <path
        d="M4.16666 4.58398H4.99999V6.66732M4.16666 6.66732H5.83332"
        className="stroke-current"
        strokeWidth="0.833333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
